import { render, staticRenderFns } from "./camSolicitud.vue?vue&type=template&id=4a2e3c7c&scoped=true"
import script from "./camSolicitud.vue?vue&type=script&lang=js"
export * from "./camSolicitud.vue?vue&type=script&lang=js"
import style0 from "./camSolicitud.vue?vue&type=style&index=0&id=4a2e3c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e3c7c",
  null
  
)

export default component.exports